import { render } from "./MPSIIICLeukocytes.vue?vue&type=template&id=548f4cef&scoped=true"
import script from "./MPSIIICLeukocytes.vue?vue&type=script&lang=js"
export * from "./MPSIIICLeukocytes.vue?vue&type=script&lang=js"

import "./MPSIIICLeukocytes.vue?vue&type=style&index=0&id=548f4cef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548f4cef"]])

export default __exports__